export default "__VITE_ASSET__185d6fda__"